import React from 'react';
import Icon from '../components/Icon';
import { SITE } from '../data/siteData';
import './LegalPage.css';

export default function TermsConditions() {
  return (
    <div className="legal-page">
      <section className="legal-hero">
        <div className="container">
          <div className="legal-label">Legal</div>
          <h1 className="legal-title">Terms &amp; Conditions</h1>
          <p className="legal-sub">Last updated: May 2025</p>
        </div>
      </section>
      <div className="legal-body container">
        <section className="legal-section">
          <h2>1. Acceptance of Terms</h2>
          <p>By accessing and using the services of LMS Marketing &amp; Services ("LMS"), you accept and agree to be bound by these Terms and Conditions. If you do not agree to these terms, please do not use our services.</p>
        </section>
        <section className="legal-section">
          <h2>2. Services Provided</h2>
          <p>LMS Marketing &amp; Services provides financial advisory, wealth management, investment planning, insurance facilitation, and loan assistance services. All advisory services are subject to SEBI regulations and applicable Indian laws.</p>
        </section>
        <section className="legal-section">
          <h2>3. Investment Disclaimer</h2>
          <p>All investments are subject to market risks. Past performance is not indicative of future results. The information provided on this website is for educational and informational purposes only and does not constitute financial advice. Please read all scheme-related documents carefully before investing.</p>
        </section>
        <section className="legal-section">
          <h2>4. SEBI Registration &amp; Compliance</h2>
          <p>LMS Marketing &amp; Services operates as a registered financial intermediary compliant with SEBI (Securities and Exchange Board of India) regulations. We are also registered with AMFI (Association of Mutual Funds in India) for mutual fund distribution.</p>
        </section>
        <section className="legal-section">
          <h2>5. Client Responsibilities</h2>
          <p>Clients are responsible for providing accurate and complete information for KYC and onboarding purposes. Any financial decisions made based on our advisory are ultimately the client's responsibility.</p>
        </section>
        <section className="legal-section">
          <h2>6. Limitation of Liability</h2>
          <p>LMS shall not be liable for any investment losses arising from market conditions, regulatory changes, or economic factors beyond our control. Our liability is limited to the advisory fees paid by the client.</p>
        </section>
        <section className="legal-section">
          <h2>7. Contact Us</h2>
          <p>For questions about these Terms, please contact us at:<br/>
          📞 {SITE.contact.phone}<br/>
          ✉ {SITE.contact.email}<br/>
          📍 {SITE.contact.address}</p>
        </section>
      </div>
    </div>
  );
}
